module.exports = __webpack_public_path__ + "static/media/white-logo.69d6c7b8.png";